import React, { useState } from 'react'
import { useEffect } from 'react'
import { useRef } from 'react'

export default function useIsMount() {
  // const isMountRef = useRef(false)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    // isMountRef.current = true
    setIsMounted(true)
    // return () => (isMountRef.current = false)
    return () => setIsMounted(false)
  }, [])

  return isMounted
}
